// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestRegister(data, toCheckout) {
  return {
    type: types.REGISTER_REQUEST,
    data,
    toCheckout,
  };
}

export function onRegisterResponse(response) {
  return {
    type: types.REGISTER_RESPONSE,
    response
  };
}
export function registerFailed(error) {
  return {
    type: types.REGISTER_FAILED,
    error
  };
}

// FIELDS

export function changeField(value, field) {
  return {
    type: types.REGISTER_FIELD_CHANGE,
    value,
    field
  };
}

export function changeFieldAddress(value, field) {
  return {
    type: types.REGISTER_ADDRESS_FIELD_CHANGE,
    value,
    field
  };
}

export function changeFieldBank(value, field) {
  return {
    type: types.REGISTER_BANK_FIELD_CHANGE,
    value,
    field
  };
}

export function changeErrors(field, error) {
  return {
    type: types.REGISTER_ERRORS_CHANGE,
    field,
    error
  };
}

// ---

export function registerFormReset() {
  return {
    type: types.REGISTER_FORM_RESET,
  };
}

export function requestSelectedAddress(data) {
  return {
    type: types.REGISTER_SELECTED_ADDRESS_REQUEST,
    data
  };
}

export function requestSelectedAddressFailed() {
  return {
    type: types.REGISTER_SELECTED_ADDRESS_REQUEST_FAILED,
  };
}

// ---

export function phoneNumberValidationFailed(error) {
  return {
    type: types.PHONE_NUMBER_VALIDATION_FAILED,
    error
  };
}
